import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";

class SettingsMenu extends Component {

  render() {
    const options = this.props.options;

    if (Object.keys(options).length === 0) {
      return '';
    }

    let optionsMenus = options.length && options.map((option, key) => {
        return (
            <Dropdown.Item key={key} href="#" onClick={() => {
                this.props.history.push(option.optionUrl);
            }}>{option.optionName}</Dropdown.Item>
        )
    })

    return (
        <Dropdown drop={"down"} className="float-right" id="t3-button-options">
            <Dropdown.Toggle variant="outline" >
            <FontAwesomeIcon icon={faEllipsisH} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {optionsMenus}
            </Dropdown.Menu>
        </Dropdown>
    )
  }
}

export default withRouter(SettingsMenu)
